import { BaseModel } from '~/models/baseModel';

export class WoolTypeMappingModel extends BaseModel {
    public woolDescription:string;
    public woolMajorType:string;
    public woolSubType:string;
}